import { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import styles from '@/styles/blog.module.scss'
import { getBlog, getTag, countBlog } from '@/service/blog.api'
import moment from 'moment'
import Link from 'next/link'
import { useRouter } from 'next/router'
import useInfiniteLoad from '@/hooks/infiniteLoad'

export default function Blog() {
  const listRef = useRef()

  const [filterReady, setFilterReady] = useState(false)

  const [selectedTag, selectTag] = useState('')
  const [tags, setTags] = useState([])

  const [blogCount, setBlogCount] = useState(0)
  const [blogs, setBlogs] = useState([])

  const limit = 1
  const [currentPage, setCurrentPage] = useState(1)
  const maxPage = useMemo(() => Math.ceil(blogCount / limit), [blogCount])
  const offset = useMemo(() => limit * (currentPage - 1), [currentPage])

  const router = useRouter()

  const loadMore = () => {
    if (currentPage >= maxPage) return
    setCurrentPage((prev) => prev + 1)
  }

  useInfiniteLoad(listRef, loadMore)

  const fetchTag = useCallback(async () => {
    if (!router.isReady) return
    const response = await getTag()
    setTags(response.data.tags)
    if (router.query.tag) {
      selectTag(router.query.tag)
    }
    setFilterReady(true)
  }, [router])

  const fetchCount = useCallback(async () => {
    const response = await countBlog(selectedTag)
    setBlogCount(response.data.blogsCount)
  }, [selectedTag])

  const fetchBlog = useCallback(async (tagFilter, offset, limit) => {
    const response = await getBlog(tagFilter, limit, offset)
    if (offset === 0) {
      setBlogs(response.data.blogs)
    } else {
      setBlogs((prev) => ([...prev, ...response.data.blogs]))
    }
  }, [])

  useEffect(() => {
    setCurrentPage(1)
  }, [selectedTag])

  useEffect(() => {
    fetchTag()
  }, [fetchTag])

  useEffect(() => {
    if (!filterReady) return
    fetchBlog(selectedTag, offset, limit)
  }, [fetchBlog, selectedTag, filterReady, offset, limit])

  useEffect(() => {
    fetchCount()
  }, [fetchCount])

  return (
    <div className={styles.blogPage}>
      <div className="max-width">
        <h1 className={styles.title}>Blog</h1>
        <div className={styles.tagWrapper}>
        <div className={`${styles.tag} ${selectedTag === '' && styles.active}`} onClick={() => selectTag('')}>
            ทั้งหมด
          </div>
          {tags.map((tag) => (
            <div className={`${styles.tag} ${selectedTag === tag.id && styles.active}`} onClick={() => selectTag(tag.id)} key={tag.id}>
              {tag.name}
            </div>
          ))}
        </div>
        <section className={styles.list} ref={listRef}>
          {
            blogs.map(({ id, thumbnail, slug, title, shortDescription, published_at }) => (
              <div className={styles.box} key={id}>
                <Link href={`/blog/${slug}`}>
                  <div className={styles.thumbWrapper}>
                    <div className={styles.thumb}>
                      <img src={thumbnail.url}/>
                    </div>
                  </div>
                </Link>
                <div className={styles.detail}>
                  <Link href={`/blog/${slug}`}>
                    <a href={`/blog/${slug}`} className={styles.name}>{title}</a>
                  </Link>
                  <div className={styles.shortDescription}>{shortDescription}</div>
                  <div className={styles.date}>{moment(published_at).format('MMMM Do YYYY')}</div>
                </div>
              </div>
            ))
          }
        </section>
      </div>
    </div>
  )
}
